import React, { ComponentProps } from 'react';
import { IMostReportedSnowfallItem } from '@/api/home/types';
import { SnowWebcams } from '@/components/home/SnowWebcams';
import MostReportedSnowfall from '@/components/home/MostReportedSnowfall';

type SnowWebcamsProps = ComponentProps<typeof SnowWebcams>;

type CamsAndSnowfallSectionProps = {
  snowWebcamsProps: SnowWebcamsProps;
  mostReportedSnowfallItems?: Array<IMostReportedSnowfallItem> | null;
  currentRegionSlug?: string;
};

// Two-column flex (webcams 2fr / snowfall 1fr) at desktop; stacks at
// the Bootstrap-lg breakpoint (~992 px). Original SCSS also added an
// extra mt-6 in the tablet sliver between 991-1199 px — approximated
// with `lg:max-xl:mt-6` (1024-1280 in Tailwind).
const sectionClass = [
  'mt-4 flex items-stretch gap-6',
  'max-lg:flex-col',
  'lg:max-xl:mt-6',
].join(' ');

const CamsAndSnowfallSection: React.FC<CamsAndSnowfallSectionProps> = ({
  snowWebcamsProps,
  mostReportedSnowfallItems,
  currentRegionSlug,
}) => {
  const hasMostReportedSnowfall = Boolean(
    mostReportedSnowfallItems?.some(({ snow }) => (snow?.last24 ?? 0) > 0),
  );
  const hasSnowWebcams = Boolean(snowWebcamsProps?.snowWebcams?.length);

  if (!hasSnowWebcams && !hasMostReportedSnowfall) {
    return null;
  }

  return (
    <section className={sectionClass}>
      {hasSnowWebcams && (
        <div className="min-w-0 flex-[2_1_0] max-lg:flex-none">
          <SnowWebcams
            {...snowWebcamsProps}
            hasMostReportedSnowfall={hasMostReportedSnowfall}
            currentRegionSlug={currentRegionSlug}
          />
        </div>
      )}
      {hasMostReportedSnowfall && (
        <div className="min-w-0 flex-1 max-lg:flex-none">
          <MostReportedSnowfall items={mostReportedSnowfallItems} />
        </div>
      )}
    </section>
  );
};

export default CamsAndSnowfallSection;
